"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DeviceConstants = require("./DeviceConstants");

var _AbstractDeviceTemplate = _interopRequireDefault(require("./AbstractDeviceTemplate"));

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  overflow-y: auto;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n  margin-top: ", ";\n\n  /* the following are all needed for IE11 */\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  @supports (display: grid) {\n    position: relative;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-radius: inherit;\n  display: grid;\n  height: 100%;\n  position: relative;\n  width: 100%;\n\n  > * {\n    grid-area: 1/1/2/2;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Outer = _styledComponents.default.div.withConfig({
  displayName: "AbstractDeviceFrame__Outer",
  componentId: "sc-12awuyk-0"
})(_templateObject());

var DisplayWrapper = _styledComponents.default.div.withConfig({
  displayName: "AbstractDeviceFrame__DisplayWrapper",
  componentId: "sc-12awuyk-1"
})(_templateObject2());

var Inner = _styledComponents.default.div.withConfig({
  displayName: "AbstractDeviceFrame__Inner",
  componentId: "sc-12awuyk-2"
})(_templateObject3(), function (props) {
  return (0, _DeviceConstants.toScaledPercentage)(props.dimensions, 'bottom');
}, function (props) {
  return (0, _DeviceConstants.toScaledPercentage)(props.dimensions, 'left');
}, function (props) {
  return (0, _DeviceConstants.toScaledPercentage)(props.dimensions, 'right');
}, function (props) {
  return (0, _DeviceConstants.toScaledPercentage)(props.dimensions, 'top');
});

var ScrollRegion = _styledComponents.default.div.withConfig({
  displayName: "AbstractDeviceFrame__ScrollRegion",
  componentId: "sc-12awuyk-3"
})(_templateObject4());

var AbstractDeviceFrame = function AbstractDeviceFrame(props) {
  var children = props.children,
      className = props.className,
      ContentWrapper = props.ContentWrapper,
      contentClassName = props.contentClassName,
      InnerWrapper = props.InnerWrapper,
      OuterWrapper = props.OuterWrapper,
      spec = props.spec,
      Template = props.Template,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "ContentWrapper", "contentClassName", "InnerWrapper", "OuterWrapper", "spec", "Template"]);
  var renderedTemplate = spec.Template;
  return _react.default.createElement(OuterWrapper, (0, _extends2.default)({}, rest, {
    className: className
  }), _react.default.createElement(DisplayWrapper, null, _react.default.createElement(Template, {
    dimensions: spec,
    Template: renderedTemplate
  }), _react.default.createElement(InnerWrapper, {
    dimensions: spec
  }, _react.default.createElement(ContentWrapper, {
    className: contentClassName,
    dimensions: spec
  }, children))));
};

AbstractDeviceFrame.propTypes = {
  children: _react.PropTypes.node.isRequired,
  ContentWrapper: _component.default,
  InnerWrapper: _component.default,
  OuterWrapper: _component.default,
  spec: _react.PropTypes.object,
  Template: _component.default,
  contentClassName: _react.PropTypes.string
};
AbstractDeviceFrame.defaultProps = {
  ContentWrapper: ScrollRegion,
  InnerWrapper: Inner,
  OuterWrapper: Outer,
  Template: _AbstractDeviceTemplate.default
};
AbstractDeviceFrame.displayName = 'AbstractDeviceFrame';
var _default = AbstractDeviceFrame;
exports.default = _default;
module.exports = exports.default;